var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4540_938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7599 7.87396L8.85989 0.977531L8.39739 0.515031C8.29201 0.410346 8.1495 0.351593 8.00097 0.351593C7.85243 0.351593 7.70992 0.410346 7.60454 0.515031L0.242038 7.87396C0.134058 7.98152 0.0487196 8.10962 -0.00894006 8.2507C-0.0665997 8.39178 -0.0954118 8.54299 -0.093676 8.69539C-0.0865331 9.32396 0.436681 9.82574 1.06525 9.82574H1.82418V15.6418H14.1778V9.82574H14.9528C15.2581 9.82574 15.5456 9.7061 15.7617 9.49003C15.8681 9.38398 15.9524 9.25788 16.0097 9.11902C16.067 8.98017 16.0962 8.83132 16.0956 8.6811C16.0956 8.37753 15.976 8.09003 15.7599 7.87396ZM9.00097 14.3561H7.00097V10.7132H9.00097V14.3561ZM12.892 8.54003V14.3561H10.1438V10.2847C10.1438 9.89003 9.82418 9.57039 9.42954 9.57039H6.57239C6.17775 9.57039 5.85811 9.89003 5.85811 10.2847V14.3561H3.10989V8.54003H1.39561L8.00275 1.93825L8.41525 2.35075L14.6081 8.54003H12.892Z",
    fill: "black",
    fillOpacity: 0.88
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4540_938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.97d6ca9c5f9d8461d86df603e79eb2f0.svg";
export { ForwardRef as ReactComponent };